import { render, staticRenderFns } from "./copy-document-template.vue?vue&type=template&id=eda3d690&scoped=true"
import script from "./copy-document-template.vue?vue&type=script&lang=js"
export * from "./copy-document-template.vue?vue&type=script&lang=js"
import style0 from "./copy-document-template.vue?vue&type=style&index=0&id=eda3d690&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda3d690",
  null
  
)

export default component.exports